import { getTeamParchmentBg } from './teamTheme';

interface ParchmentLayoutProps {
  teamColor?: string;
  children: React.ReactNode;
  className?: string;
  fullHeight?: boolean;
}

function ParchmentLayout({ teamColor, children, className = '', fullHeight = false }: ParchmentLayoutProps) {
  const teamBg = teamColor ? getTeamParchmentBg(teamColor) : '';
  const heightClass = fullHeight ? 'h-screen' : 'min-h-screen';

  return (
    <div className={`${heightClass} parchment-bg ${teamBg} ${className}`}>
      {children}
    </div>
  );
}

export default ParchmentLayout;
